import React, { useState } from "react";
import "../components/AceternityForm/AceternityForm.css";
import BorderGlow from "../components/BorderGlow/BorderGlow";
import { GrUserAdmin } from "react-icons/gr";
import { LuEyeOff, LuEye } from "react-icons/lu";
import { loginAsocias } from "../services/Asocias/loginAsocias";
import { useNavigate } from "react-router-dom";

export const AsociaLoginForm = () => {
  const navigate = useNavigate();
  const [cedula, setCedula] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [mostrarContrasena, setMostrarContrasena] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); // Limpiar errores previos antes de intentar iniciar sesión

    try {
      const response = await loginAsocias({
        userName: cedula,
        password: contrasena,
      });

      if (response.success) {
        // Guardar el usuario en localStorage para futuras verificaciones
        localStorage.setItem("asociaName", response.data.name);
        localStorage.setItem("asociaId", response.data.id);

        navigate("/asocias/admin", {
          state: { nombre: response.data.name, id: response.data.id },
        });
      } else {
        setError(response.message); // Mostrar el mensaje de error si el login falla
      }
    } catch (error) {
      console.error("Error en el inicio de sesión:", error);
      setError("Error en la verificación del usuario");
    }
  };

  return (
    <div className="aceternity-form-page">
      <div className="aceternity-form-wrapper">
        <BorderGlow className="aceternity-glow-wrap" borderRadius={16} backgroundColor="transparent">
        <div className="aceternity-form-card">
          <h2 className="aceternity-form-title">Volteon Electronics</h2>
          <p className="aceternity-form-subtitle">Asociaciones</p>

          <form onSubmit={handleLogin} className="aceternity-form">
            <div className="aceternity-form-row">
              <div className="aceternity-input-icon-wrap">
                <GrUserAdmin className="aceternity-input-icon-left" />
                <input
                  className="aceternity-input"
                  type="text"
                  placeholder="Usuario"
                  required
                  value={cedula}
                  onChange={(e) => setCedula(e.target.value)}
                />
              </div>
            </div>

            <div className="aceternity-form-row">
              <div className="aceternity-input-icon-wrap">
                <input
                  className="aceternity-input"
                  type={mostrarContrasena ? "text" : "password"}
                  placeholder="Contraseña"
                  required
                  value={contrasena}
                  onChange={(e) => setContrasena(e.target.value)}
                  style={{ paddingLeft: "0.85rem" }}
                />
                <span
                  title={mostrarContrasena ? "Ocultar contraseña" : "Mostrar contraseña"}
                  onClick={() => setMostrarContrasena(!mostrarContrasena)}
                  className="aceternity-input-icon-right"
                >
                  {mostrarContrasena ? <LuEyeOff /> : <LuEye />}
                </span>
              </div>
            </div>

            {error && <p style={{ color: "#ff6b6b", fontSize: "0.85rem" }}>{error}</p>}

            <button type="submit" className="aceternity-btn-primary">
              Iniciar Sesión &rarr;
            </button>
          </form>
        </div>
        </BorderGlow>
      </div>
    </div>
  );
};
